import client from "./client";

export const login = async (
  username: string,
  password: string
): Promise<any> => {
  return await client
    .post("/auth/login-2fa", { username, password })
    .then(response => response.data.response);
};

export const validateMfa = async (
  mfaToken: string,
  code: string
): Promise<any> => {
  return await client
    .post("/auth/mfa/validate", { mfaToken, code })
    .then(response => response.data.response);
};

export const validateBackupCode = async (
  mfaToken: string,
  backupCode: string
): Promise<any> => {
  return await client
    .post("/auth/mfa/validate-backup", { mfaToken, backupCode })
    .then(response => response.data.response);
};

export const loginWithLink = async (token: string): Promise<any> => {
  return await client
    .post("/auth/login-link", { token })
    .then(response => response.data.response);
};

export const resetPassword = async (
  password: string,
  token: string
): Promise<any> => {
  return await client
    .post(`/auth/reset-password`, {
      password,
      token
    })
    .then(response => response.data.response);
};

// Fetch the non-sensitive identity fields (username/name) tied to a reset
// token, used only to drive the "must not contain your username or name"
// live-feedback rule on the reset form. Read-only; issues no session.
export const fetchResetIdentity = async (token: string): Promise<any> => {
  return await client
    .post(`/auth/reset-password/identity`, { token })
    .then(response => response.data.response);
};

export const changePassword = async (
  currentPassword: string,
  newPassword: string
): Promise<any> => {
  return await client
    .put(`/profiles/change-password`, {
      attributes: {
        currentPassword,
        password: newPassword
      }
    })
    .then(response => response.data.response);
};

export const forgotPassword = async (email: string): Promise<any> => {
  return await client
    .post(`/auth/forgot-password`, { email })
    .then(response => response.data.response);
};
